import { render } from "./PatientReportPreview.vue?vue&type=template&id=7095ac49&scoped=true"
import script from "./PatientReportPreview.vue?vue&type=script&lang=js"
export * from "./PatientReportPreview.vue?vue&type=script&lang=js"

import "./PatientReportPreview.vue?vue&type=style&index=0&id=7095ac49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7095ac49"]])

export default __exports__